const daysLong = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function getDaysShort(intl) {
  return [
    capitalize(intl.formatDate('September 15, 2024', { weekday: 'short' })), // Sunday
    capitalize(intl.formatDate('September 16, 2024', { weekday: 'short' })), // Monday
    capitalize(intl.formatDate('September 17, 2024', { weekday: 'short' })), // Tuesday
    capitalize(intl.formatDate('September 18, 2024', { weekday: 'short' })), // Wednesday
    capitalize(intl.formatDate('September 19, 2024', { weekday: 'short' })), // Thursday
    capitalize(intl.formatDate('September 20, 2024', { weekday: 'short' })), // Friday
    capitalize(intl.formatDate('September 21, 2024', { weekday: 'short' })), // Saturday
  ];
}

function to12hours(time) {
  const [h, m] = time.split(':').map(Number);
  const period = h >= 12 ? 'PM' : 'AM';
  return `${h % 12 || 12}:${String(m).padStart(2, '0')} ${period}`;
}

function formatDays(startDay, endDay, intl) {
  const ldaysShort = getDaysShort(intl);
  return startDay === endDay ? `${ldaysShort[startDay]}: ` : `${ldaysShort[startDay]}-${ldaysShort[endDay]}: `;
}

function groupOpeningHours(openHours, intl) {
  if (!intl || !intl.formatMessage) {
    return '';
  }

  const localDaysShort = getDaysShort(intl);
  const operatingHours = openHours || {};
  const groupedHours = [];

  let currentGroupStartDay = null;
  let currentGroupEndDay = null;
  let lastOpens = null;
  let lastCloses = null;

  localDaysShort.forEach((abbrDay, index) => {
    const fullDayName = daysLong[index].toLowerCase();
    const dayHours = operatingHours[fullDayName] || [];

    if (dayHours.length === 0) {
      if (currentGroupStartDay !== null) {
        groupedHours.push(
          `${formatDays(currentGroupStartDay, currentGroupEndDay, intl)}${to12hours(lastOpens)} - ${to12hours(lastCloses)}`,
        );
        currentGroupStartDay = null;
      }
      return;
    }

    if (dayHours.length > 1) {
      if (currentGroupStartDay !== null) {
        groupedHours.push(
          `${formatDays(currentGroupStartDay, currentGroupEndDay, intl)}${to12hours(lastOpens)} - ${to12hours(lastCloses)}`,
        );
        currentGroupStartDay = null;
      }
      const shiftsStr = dayHours
        .map((shift) => `${to12hours(shift.opens)} - ${to12hours(shift.closes)}`)
        .join(', ');
      groupedHours.push(`${abbrDay}: ${shiftsStr}`);
      return;
    }

    const { opens, closes } = dayHours[0];
    if (opens === lastOpens && closes === lastCloses && currentGroupStartDay !== null) {
      currentGroupEndDay = index;
    } else {
      if (currentGroupStartDay !== null) {
        groupedHours.push(
          `${formatDays(currentGroupStartDay, currentGroupEndDay, intl)}${to12hours(lastOpens)} - ${to12hours(lastCloses)}`,
        );
      }
      currentGroupStartDay = index;
      currentGroupEndDay = index;
      lastOpens = opens;
      lastCloses = closes;
    }
  });

  if (currentGroupStartDay !== null) {
    groupedHours.push(
      `${formatDays(currentGroupStartDay, currentGroupEndDay, intl)}${to12hours(lastOpens)} - ${to12hours(lastCloses)}`,
    );
  }

  return groupedHours.join(', ');
}

export default groupOpeningHours;
